import React from 'react';
import SpinnerOverlay from 'src/components/common/SpinnerOverlay';
import PDAHeader from 'src/components/common/Header';
import usePDA1120_R01Store from './usePDA1120_R01Store';
import { usePDAContainer } from 'src/hooks/usePDAContainer';
import PDA1120_R01Content from './PDA1120_R01Content';
import PDA1120_R01Search from './PDA1120_R01Search';
import PDA1120_R01Table from './PDA1120_R01Table';
import PDA1120_R01Info from './PDA1120_R01Info';
import  PDA1120_R01DetailTable from './PDA1120_R01DetailTable';

interface PDA1120_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

/**
 * PDA1120_R01 피더 자재투입 체크 컨테이너
 * 
 * 레이아웃:
 * - 작업지시 미선택 시: 검색 + 작업지시 목록
 * - 작업지시 선택 시: 피더 정보 + 피더 목록
 */
const PDA1120_R01Container: React.FC<PDA1120_R01ContainerProps> = ({
  menuNm,
  menuCd,
  onBack,
}) => {

  // Store에서 상태 가져오기
  const { loading, reset, orderList, selectedOrder, feederList } = usePDA1120_R01Store();

  // 공통 PDA 컨테이너 로직 (Reset 등록, 메뉴 클릭 핸들러)
  const { handleMenuClick } = usePDAContainer(reset);

  // 비즈니스 로직 (개선된 실장/완료 로직 포함)
  const {
    fetchData,
    handleRefetchOrders,
    fetchDetailTableData,
    fetchInfoData,
    handleMount,
    handleSaveClick,
    handleRemoveCheckItem,
    handleCancelAll,
    handleBackToList,
    checkedCount
  } = PDA1120_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      {/* 헤더 */}
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={selectedOrder ? handleBackToList : onBack}
        onMenuClick={handleMenuClick}
      />

      {/* 작업지시 미선택 시: 검색 + 작업지시 목록 */}
      {!selectedOrder && (
        <>
          {/* 검색 영역 */}
          <PDA1120_R01Search onSearch={fetchData} onRefetch={handleRefetchOrders} />

          {/* 작업지시 목록 그리드 */}
          <div className="flex-1 overflow-hidden">
            <PDA1120_R01Table
              orderList={orderList}
              onSelectOrder={fetchDetailTableData}
            />
          </div>
        </>
      )}

      {/* 작업지시 선택 시: 피더 정보 + 피더 목록 */}
      {selectedOrder && (
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* 피더 체크 정보 */}
          <div className="border-b border-gray-300">
            <PDA1120_R01Info
              onScanLot={fetchInfoData}
              checkedCount={checkedCount}
              onMount={handleMount}
              onComplete={handleSaveClick}
              onRemoveCheckItem={handleRemoveCheckItem}
              onCancelAll={handleCancelAll}
            />
          </div>

          {/* 피더 목록 그리드 */}
          <div className="flex-1 overflow-hidden">
            < PDA1120_R01DetailTable
              feederList={feederList}
              onSelectFeeder={(feeder) => {
                usePDA1120_R01Store.getState().setSelectedFeeder(feeder);
              }}
            />
          </div>
        </div>
      )}

      {loading && <SpinnerOverlay text="처리 중입니다..." />}
    </div>
  );
};

export default PDA1120_R01Container;

